import React, { useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import VehicleDialog from "./VehicleDialog";
import Box from "@mui/material/Box";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import CheckIcon from "@mui/icons-material/Check";
import { getData, postData } from "../api/AuthenticatedApiCaller";
import { VehiclesApi } from "../api/AdminApi";
import { TableContainer } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { VehicleAddDialog } from "./VehicleAddDialog";

export default function VehicleView() {
  const [editedVehicle, setEditedVehicle] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [vehicles, setVehicles] = useState(null);
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    if (vehicles === null || update) {
      fetchData();
    }
    setUpdate(false);
  }, [update]);

  async function fetchData() {
    const [data, error] = await getData(VehiclesApi.getAll);
    if (error) {
      // Handle the error
    } else {
      setVehicles(data);
    }
  }

  async function setActivity(id, isActive) {
    const [data, error] = await postData(
      VehiclesApi.setActivity + "?id=" + id + "&isActive=" + isActive
    );
    if (error) {
      // Handle the error
    } else {
      setUpdate(true);
    }
  }

  return (
    <Box>
      {isDialogOpen === true && (
        <VehicleAddDialog
          open={isDialogOpen}
          vehicle={editedVehicle}
          save={() => {
            setIsDialogOpen(false);
            setUpdate(true);
          }}
          cancel={() => setIsDialogOpen(false)}
        />
      )}

      <Button
        onClick={() => {
          setIsDialogOpen(true);
          setEditedVehicle(null);
        }}
        variant="outlined"
      >
        Create Vehicle
      </Button>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow id="header">
              <TableCell>Id</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Rate</TableCell>
              <TableCell>Current Rate</TableCell>
              <TableCell>Active</TableCell>
              <TableCell>Edit</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vehicles !== null &&
              vehicles.data.map((vehicle) => (
                <TableRow key={vehicle.id}>
                  <TableCell>{vehicle.id}</TableCell>
                  <TableCell>{vehicle.title}</TableCell>
                  <TableCell>{vehicle.rate}</TableCell>
                  <TableCell>{vehicle.currentRate}</TableCell>
                  {vehicle.active !== true ? (
                    <TableCell>
                      <IconButton>
                        <DoNotDisturbIcon
                          onClick={() => setActivity(vehicle.id, true)}
                        />
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell>
                      <IconButton>
                        <CheckIcon
                          onClick={() => setActivity(vehicle.id, false)}
                        />
                      </IconButton>
                    </TableCell>
                  )}

                  <TableCell>
                    <IconButton>
                      <EditIcon
                        onClick={() => {
                          setEditedVehicle(vehicle);
                          setIsDialogOpen(true);
                        }}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
